// Pagina Password Dimenticata
// Permette di richiedere il reset della password

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, Mail, Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/password/forgot`, { email });
      setSent(true);
    } catch (error) {
      toast.error('Si è verificato un errore. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="h-8 w-8 text-green-600" />
            </div>
            <h2 className="text-xl font-semibold mb-2">Email Inviata!</h2>
            <p className="text-muted-foreground mb-6">
              Se l'indirizzo <strong>{email}</strong> è registrato, riceverai un'email con le istruzioni per reimpostare la password.
            </p>
            <p className="text-sm text-muted-foreground mb-6">
              Controlla anche la cartella spam se non vedi l'email entro qualche minuto.
            </p>
            <Link to="/auth">
              <Button variant="outline" className="gap-2">
                <ArrowLeft className="h-4 w-4" />
                Torna al Login
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="forgot-password-page">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <Link to="/auth">
            <Button variant="ghost" size="sm" className="gap-2 mb-2 -ml-2">
              <ArrowLeft className="h-4 w-4" />
              Torna al Login
            </Button>
          </Link>
          <CardTitle className="text-2xl">Password Dimenticata?</CardTitle>
          <CardDescription>
            Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="email@esempio.com"
                  className="pl-10"
                  data-testid="forgot-password-email"
                />
              </div>
            </div>
            <Button 
              type="submit" 
              className="w-full"
              disabled={loading || !email}
              data-testid="forgot-password-submit"
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Invio in corso...
                </>
              ) : (
                'Invia Istruzioni'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
